import './vendor';
import './helpers';
import './analytics';
import './components/menu';
import './components/index';
import './components/article';
import './components/share';
import router from './components/router';

router.start();
